module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAPCAYAAADtc08vAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACESURBVHgBxZHRDYAgDERb4wJu4Cau4iaOIpuom7iBcQI8sCYGUcF++JKGJvTacrAFpEHTwGkLUsK/P4G0G3zyADN7u9OVlIkT42BEhVi8iQxyxKCVfE32QNY2YZ7kQWSyz5MaPImPgihy50RjuPaZgm+Q+0ZmDJfJwts31ogZMUFsYgUbhp2Iu5NvWJIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/sign.png
// module id = OJbn
// module chunks = 36